import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { messages as i } from "./messages.mjs";
import { Button as n } from "./index26.mjs";
import { Drawer as g, Stack as o, Divider as f, Grid as l } from "@mui/material";
import { Typography as a } from "./index59.mjs";
const B = (c) => {
  const {
    locale: t,
    onAgreeClick: s,
    onLogOutClick: p,
    isAgreeButtonLoading: m,
    isPreview: u,
    testId: h
  } = c;
  return /* @__PURE__ */ e(g, { open: !0, anchor: "bottom", disablePortal: !0, disableScrollLock: u, children: /* @__PURE__ */ e(
    o,
    {
      position: "fixed",
      bottom: 0,
      "data-testid": h,
      maxHeight: "85vh",
      sx: { outline: "none" },
      padding: 0,
      children: /* @__PURE__ */ e(
        o,
        {
          bgcolor: (r) => r.palette.background.level3,
          borderRadius: 4,
          borderColor: (r) => r.palette.divider,
          sx: {
            overflowY: "auto",
            overflowX: "hidden",
            borderWidth: 1,
            borderStyle: "solid",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
          },
          children: /* @__PURE__ */ d(o, { gap: 3, paddingY: 3, children: [
            /* @__PURE__ */ d(o, { gap: 3, paddingX: 3, children: [
              /* @__PURE__ */ e(a.H5, { color: (r) => r.palette.text.primary, children: i.title[t] }),
              /* @__PURE__ */ e(a.Body1, { color: (r) => r.palette.text.primary, children: i.description[t] })
            ] }),
            /* @__PURE__ */ e(f, {}),
            /* @__PURE__ */ d(l, { container: !0, spacing: 2, paddingX: 3, justifyContent: "flex-end", children: [
              /* @__PURE__ */ e(l, { xs: 6, item: !0, children: /* @__PURE__ */ e(
                n,
                {
                  variant: "tertiary",
                  size: "medium",
                  color: "primary",
                  fullWidth: !0,
                  onClick: p,
                  children: i.logOutButton[t]
                }
              ) }),
              /* @__PURE__ */ e(l, { xs: 6, item: !0, children: /* @__PURE__ */ e(
                n,
                {
                  variant: "contained",
                  size: "medium",
                  color: "primary",
                  fullWidth: !0,
                  onClick: s,
                  isLoading: m,
                  children: i.agreeButton[t]
                }
              ) })
            ] })
          ] })
        }
      )
    }
  ) });
};
export {
  B as AcceptPoliciesDrawer
};
//# sourceMappingURL=index241.mjs.map
